<template lang="html">
    <v-form v-model="isValid" ref="form">
        <v-container grid-list-xs>
            <v-layout wrap>
                <v-flex xs12>
                    <v-text-field label="Prénom" v-model="model.first_name" :rules="rules.first_name" required></v-text-field>
                </v-flex>
                <v-flex xs12>
                    <v-text-field label="Nom" v-model="model.last_name" :rules="rules.last_name" required></v-text-field>
                </v-flex>
                <v-flex xs12>
                    <v-text-field label="Email" v-model="model.email" :rules="rules.email" required></v-text-field>
                </v-flex>
                <v-flex xs12 v-if="!params.user">
                    <v-text-field label="Mot de passe" type="password" v-model="model.password" :rules="rules.password" required></v-text-field>
                </v-flex>
                <v-flex xs12>
                    <v-select
                        v-model="model.role_id"
                        :rules="rules.role_id"
                        label="Rôle"
                        :items="roles"
                        item-text="label"
                        item-value="id"
                        clearable
                        dense
                        required
                        >
                    </v-select>
                </v-flex>
            </v-layout>
        </v-container>
    </v-form>
</template>

<script>
    export default {
        props: {
            params: {
                required: false
            }
        },

        data() {
            return {
                title:      'Ajouter un utilisateur',
                icon:       'mdi-account-settings-variant',

                isValid:    false,

                model: {
                    first_name:     '',
                    last_name:      '',
                    email:          '',
                    password:       '',
                    role_id:        ''
                },

                rules: {
                    first_name: [
                        (v) => !!v || 'Prénom obligatoire',
                    ],
                    last_name: [
                        (v) => !!v || 'Nom obligatoire',
                    ],
                    email: [
                        (v) => !!v || 'Email obligatoire',
                        (v) => /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'Adresse email non valide'
                    ],
                    password: [
                        (v) => !!v || 'Mot de passe obligatoire'
                    ],
                    role_id: [
                        (v) => !!v || 'Rôle obligatoire'
                    ]
                },

                roles: []
            }
        },

        methods: {
            onClose() {
                this.$eventHub.$emit('close-modal')
            },

            onValidate() {
                if(this.$refs.form.validate()) {
                    if(this.params.user) {
                        this.axios.put(`/api/users/${this.params.user.id}`, this.model)
                        .then(response => {
                            this.$eventHub.$emit('close-modal')
                            this.$eventHub.$emit('reload-list')
                        })
                        .catch(err => console.log(err.response.data))

                    } else {
                        this.axios.post('/api/users', this.model)
                        .then(response => {
                            this.$eventHub.$emit('close-modal')
                            this.$eventHub.$emit('reload-list')
                        })
                        .catch(err => console.log(err.response.data))
                    }

                } else {
                    return false
                }
            }
        },

        created() {
            if(this.params.user) {
                this.model.first_name   = this.params.user.first_name
                this.model.last_name    = this.params.user.last_name
                this.model.email        = this.params.user.email
                this.model.role_id      = this.params.user.role_id
            }

            this.axios.get('/api/roles')
                .then(res => this.roles = res.data)
                .catch(err => console.log(err.response.data))
        }

    }
</script>

<style lang="stylus" scoped>

</style>



// WEBPACK FOOTER //
// src/views/admin/users/list/Create.vue